// extracted by mini-css-extract-plugin
module.exports = {"select":"Deals_select__2avxJ","name":"Deals_name__hqFb4","table":"Deals_table__2-p_0"};